import { BeeswaxReportProperties as ReportProperty } from '@/Enums/Report/BeeswaxReportProperties.enum';
import { IControlOption } from '@/Interfaces/ControlOption.interface';
import { IBasePlacementReportRecord } from '@/Interfaces/Reporting/BaseReportRecord.interface';

interface IBaseFilters {
  campaigns?: IControlOption[];
  placement?: IControlOption[];
}

export const placementReportToControlOptions = (
  filters: IBaseFilters,
  placementReport: IBasePlacementReportRecord[],
) => {
  if (!filters.campaigns?.length || filters.placement?.length) {
    return [];
  }
  return placementReport.map(item => {
    return {
      value: item[ReportProperty.LINE_ITEM_ID],
      label: item[ReportProperty.LINE_ITEM_NAME],
    };
  });
};
